import { LabelWrapper, LabelText, LabelNameWrapper } from './styled';
import { useEffect, useMemo, useRef, useState } from 'react';
import { Text } from '@simplywallst/ui-core';

interface Props {
  peerName: string;
  peerRatio: string;
  selected: boolean;
  chartWidth: number;
  barWidth: number;
  barWidthPercent: number;
}
export const PeerLabel = ({
  peerName,
  peerRatio,
  selected,
  chartWidth,
  barWidth,
  barWidthPercent,
}: Props) => {
  const [peerLabelWidth, setPeerLabelWidth] = useState(0);
  const addedGutter = 16;
  //Check if label should overflow to the right of the horizontal bar
  const shouldOverflow =
    chartWidth > 0 &&
    peerLabelWidth > barWidth && //Label is larger than containing bar
    barWidth < chartWidth / 2; //Containing bar extends less than 1/2 the chart
  const peerRowWidth = barWidth + peerLabelWidth - addedGutter;
  const labelWidth = useMemo(() => {
    if (shouldOverflow && peerRowWidth > chartWidth) return '100%';
    if (!shouldOverflow && peerLabelWidth > barWidth) return '100%';
    return 'fit-content';
  }, [shouldOverflow, peerRowWidth, peerLabelWidth, barWidth, chartWidth]);
  const labelRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const { current } = labelRef;
    if (current && peerLabelWidth === 0)
      setPeerLabelWidth(current.getBoundingClientRect().width);
  }, [peerLabelWidth]);

  return (
    <LabelWrapper
      width={shouldOverflow ? 100 - barWidthPercent : barWidthPercent}
      translateTo={shouldOverflow ? barWidth : 0}
    >
      <LabelText
        width={'fit-content'}
        hasBackground={shouldOverflow || (selected && shouldOverflow)}
      >
        <Text typography="xSmallStrong">{peerRatio}</Text>
      </LabelText>
      <LabelNameWrapper width={labelWidth} minWidth={labelWidth} ref={labelRef}>
        <LabelText
          selected={selected}
          hasBackground={shouldOverflow || selected}
          width={labelWidth}
        >
          <Text
            typography="xSmall"
            color="whiteRGBA"
            opacity={selected ? 1 : 0.8}
            isTruncated
          >
            {peerName}
          </Text>
        </LabelText>
      </LabelNameWrapper>
    </LabelWrapper>
  );
};
